import store from '../store/store';
import { mutatorAction } from 'satcheljs';
import { DomainConnectFetchSetupResponse } from 'owa-domain-connect';

export default mutatorAction('setDomainState', function setDomainState(
    response: DomainConnectFetchSetupResponse
) {
    if (response.domainData) {
        store.domainState.isValid = response.domainData.isDomainValidated;
        store.domainState.domainName = response.domainData.domainName;
        store.domainState.isDomainCreated = true;
        store.domainState.domainPurchaseDate = new Date(response.domainData.domainPurchaseDate);
    } else {
        store.domainState.isDomainCreated = false;
        store.domainState.isValid = false;
        store.domainState.domainName = '';
    }
});
